import { getYourSubscriptions } from "@/lib/api/discover"
import { DataSource } from "./base"
import { DataSourcePagination } from "../types"
import { TrendingEntry } from "@/types/farcaster"

/**
 * See the ForYouSource.tsx for why we use a high number here.
 *
 * Ideally we should use the same number as in the ForYouSource, so the API call is cached.
 */
const SUBSCRIPTION_PAGE_SIZE = 100

export default class SubscriptionsDataSource implements DataSource {
  constructor(private userId?: string) {}

  async fetchMore(props?: DataSourcePagination) {
    if (!this.userId) return null
    const data = await getYourSubscriptions(
      this.userId,
      props?.page,
      SUBSCRIPTION_PAGE_SIZE
    )

    const pagination = this.updatePagination({
      currentPagination: props,
      newData: data,
    })
    return { data, pagination }
  }

  getInitialPagination() {
    return { page: 1 }
  }

  updatePagination(props?: {
    currentPagination?: DataSourcePagination
    newData: TrendingEntry[]
  }) {
    const oldPage = props?.currentPagination?.page || 1

    return { page: oldPage + 1 }
  }
}
